import { reconciliationSummary } from '../reviewMoneyModel';
import type { ReviewDetail } from '../reviewTypes';

/**
 * The figures, in words.
 *
 * Five numbers and a subtraction left the reader to work out the story — and a
 * bare "Unreconciled $13.40" says neither which direction the gap runs nor
 * whether it is the reason this item is flagged. A settled $0.00 is stated out
 * loud too, because a silent zero is indistinguishable from a card that failed to
 * load, and the operator still needs to know the flag was not about money.
 */
export default function ReviewMoneyExplanation({ detail }: { detail: ReviewDetail }) {
  const summary = reconciliationSummary(detail);
  if (!summary) return null;
  return (
    <div
      style={{
        marginTop: 2,
        background: summary.settled ? 'var(--nb-primary-soft)' : 'var(--nb-warn-soft)',
        borderRadius: 10,
        padding: '10px 12px',
        fontSize: 11.5,
        lineHeight: 1.55,
        color: 'var(--nb-ink-2)',
      }}
    >
      {summary.text}
    </div>
  );
}
